import 'css-chunksrc/client/scenes/startDiscussion/recipientInput/styles.scss';export default {
  "recipients": "_recipients_1g7fr_1",
  "recipient": "_recipient_1g7fr_1",
  "iconBox": "_iconBox_1g7fr_19",
  "list": "_list_1g7fr_23",
  "icon": "_icon_1g7fr_19"
};